<template>
  <div class="page_all">
    <div class="return_link"></div>   
    <div class="page_header">
      <div class="header_title">
        <div class="title">外部リンク</div>
        <div class="area_radios_div">
          <div class="area_radio_div" v-for="language in languages" v-bind:key="language.language_id">
            <input class="area_radio_input" :id="'ja_radio_' + language.language_id" type="radio" :value="language.language_id" v-model=languageRadio>
            <label class="area_radio_label" :for='"ja_radio_" + language.language_id'>
                {{ language.language_name}}
            </label>
          </div>
          <!-- <div class="area_radio_div">
            <input class="area_radio_input" id="en_radio" type="radio" value="en" v-model="languageRadio">
            <label class="area_radio_label" for="en_radio">
              英語
            </label>
          </div>
          <div class="area_radio_div">
            <input class="area_radio_input" id="kan_radio" type="radio" value="ko" v-model="languageRadio">
            <label class="area_radio_label" for="kan_radio">
              韓国語
            </label>
          </div>
          <div class="area_radio_div">
            <input class="area_radio_input" id="chu_han_radio" type="radio" value="zh-Hant" v-model="languageRadio">
            <label class="area_radio_label" for="chu_han_radio">
              中国語(繁体字)
            </label>
          </div>
          <div class="area_radio_div">
            <input class="area_radio_input" id="chu_kan_radio" type="radio" value="zh-Hans" v-model="languageRadio">
            <label class="area_radio_label" for="chu_kan_radio">
              中国語(簡体字)
            </label>
          </div> -->
        </div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <div>
        <button class="btn_plus" v-on:click="linkAdd()">＋</button>
      </div>
    </div>
    <div class="page_header_2">
      <div class="page_header_2_sub">
        *設定がない言語の場合は、プライマリー言語の内容がアプリに表示されます。
      </div>
      <div class="page_header_2_sub">
        プライマリー言語に設定がない場合は、日本語の内容を表示します。
      </div>
      <div class="page_header_2_message">
        {{ languageMessage }}
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_group">グループ</th>
            <th class="th_title">タイトル</th>
            <th class="th_link">リンク</th>
            <th class="th_delete"></th>
          </tr>
        </thead>
        <template v-if="links != null" >
          <!-- ja -->
          <!-- <tbody v-if="languageRadio == 1">
            <tr v-for="link in links.filter(x => x.language_kind == 1 || x.language_kind == null)" v-bind:key="link.id">
              <td class="td_group">{{ link.group_name }}</td>
              <td class="td_title">
                <router-link v-on:click.native="linkUpdate(link.link_id, link.link_title, link.link_url, link.group_name)" to="">{{ link.link_title }}</router-link>
              </td>
              <td class="td_link"><a v-bind:href="link.link_url" target="_blank">{{ link.link_url }}</a></td>
              <td class="td_delete">
                <button class="btn_delete" v-on:click="linkDel(link.link_id)">X</button>
              </td>
            </tr>
          </tbody> -->
          <template v-for="language in languages">
            <tbody v-if="languageRadio == language.language_id" :key="language.language_id">
              <tr v-for="link in getLinksLanguage(language.language_id)" v-bind:key="link.id">
                <td class="td_group">{{ link.group_name }}</td>
                <td class="td_title">
                  <router-link v-on:click.native="linkUpdate(link.link_id, link.link_title, link.link_url, link.group_name)" to="">{{ link.link_title }}</router-link>
                </td>
                <td class="td_link"><a v-bind:href="link.link_url" target="_blank">{{ link.link_url }}</a></td>
                <td class="td_delete">
                  <button class="btn_delete" v-on:click="linkDel(link.link_id)">X</button>
                </td>
              </tr>
            </tbody>
          </template>
        </template>
      </table>
    </div>
    <confirm-dialog ref="deleteDialog" primary-label="削除" secondary-label="キャンセル"/>
  </div>
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog";
import store from '@/store/store'

export default {
  components: {
    ConfirmDialog
  },
  data() {
    // console.log(this.prevRouteCompute)
    // console.log(this.$store.getters.getStateLinkLanguage)
    // console.log(this.languageRadio)
    return {
      links: null,
      languageRadio: this.prevRouteCompute == 'linkDetail' ? this.$store.getters.getStateLinkLanguage : 1,
      primaryLanguage: "",
      languages: "",
      languageId: 1,
      prevRoute: "",
      languageMessage: "",
      // メッセージ
      message: ""
    }
  },
  beforeRouteEnter(to, from, next) {
    store.commit('setStatePrevRoute', from.name)
    next(vm => {
      vm.prevRoute = from
      // console.log(vm.prevRoute.name)
    })
  },
  mounted() {
    this.languageRadio = this.prevRouteCompute == 'linkDetail' && this.$store.getters.getStateLinkLanguage || 1,

    // 自治体情報:プライマリー言語
    this.getMunicipality()
    // リンク情報取得
    this.getLinkList()
    // グループ情報取得
    this.getGroupList()
  },
  beforeUpdate() {
    // this.languageRadio = this.prevRouteCompute == 'linkDetail' ? this.$store.getters.getStateLinkLanguage : 1
  },
  methods: {
    async getMunicipality() {
      try {
        const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'primary-language/detail', {
          params: {
            municipality_key: this.$store.getters.getStateMunicipalityKey
          }
        })
        console.log(response.data)
        this.languages = response.data.language
        this.languageId = response.data.municipality[0].primary_language
        this.message = ""

      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async getLinkList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'link/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
        }
      })
      this.links = response.data.links
      this.primaryLanguage = response.data.municipality.primary_language

      // console.log(this.primaryLanguage)
    },
    async linkDel(link_id) {
      const link = this.links && this.links.find(link => link.link_id === link_id) || null;
      if (!link) {
        return;
      }
      const result = await this.$refs.deleteDialog.asyncShow(`${link.link_title}を削除してよろしいですか？`);
      if (!result) {
        return;
      }
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'link/del', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          link_id: link_id,
          charge_id: this.$store.getters.getStateChargeId
        })
        this.getLinkList()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    getGroupList: function() {
      this.$store.dispatch('getStateGroupList', this.$store.getters.getStateMunicipalityKey)
    },
    linkAdd: function() {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', false)
      // 選択言語
      this.$store.commit('setStateLinkLanguage', this.languageRadio)
      this.$router.push({ name: 'linkDetail' })
    },
    linkUpdate: function(link_id) {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', true)
      // リンクコードをStoreにセット
      this.$store.commit('setStateLinkId', link_id)
      // 選択言語
      this.$store.commit('setStateLinkLanguage', this.languageRadio)
      this.$router.push({ name: 'linkDetail' })
    },
    getLinksLanguage: function (language) {
      var resultLinks = []
      var languageLinks

      if (language == 1) {
        languageLinks = this.links.filter(x => x.language_kind == language || x.language_kind == null)
      } else {
        languageLinks = this.links.filter(x => x.language_kind == language)  
      }

      if (languageLinks.length == 0) {
        const languagePrimary = this.links.filter(x => x.language_kind == this.primaryLanguage)
        if (languagePrimary.length == 0) {
          // 日本語
          resultLinks = this.links.filter(x => x.language_kind == 1 || x.language_kind == null) 
        } else {
          // プライマリー言語
          resultLinks = languagePrimary
        }

        this.languageMessage = "* 設定が無いため、プライマリー言語もしくは日本語の内容を表示しています。"
      } else {
        // 選択言語
        resultLinks = languageLinks

        this.languageMessage = ""
      }
      
      return resultLinks
    }
  },
  computed: {
    prevRouteCompute() {
      return this.$store.getters.getStatePrevRoute
    }
  }
}
</script>

<style scoped>
.page_header_2 {
  margin: 10px 0 0 0;
}
.page_header_2_sub {
  font-size: x-small;
  text-align: left;
}
.page_header_2_message {
  font-size: x-small;
  text-align: left;
  color: red;
  margin: 10px 0 5px 0;
}
.area_radios_div {
  display: flex;
  margin: 0 0 0 30px;
}
.area_radio_div {
  margin: 0 10px 0 0;
  font-size: smaller;
}
.area_radio_label {
  margin: 2px 0 0 0;
}
.tbl_main {
  table-layout: fixed;
}
table th.th_group {
  width: 120px;
}
table th.th_title {
  width: 250px;
}
table th.th_link {
  width: 400px;
}
table th.th_delete {
  width: 30px;
}

table td {
  word-break: break-all;
}
table td.td_group {
  text-align: left;
  padding-left: 10px;
}
table td.td_title {
  text-align: left;
  padding-left: 10px;
  overflow-wrap : break-word;
}
table td.td_link {
  text-align: left;
  padding-left: 10px;
  /* overflow: scroll; */
  /* overflow-wrap : break-word; */
  word-break : break-all;
  /* text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 0; */
}
table td.td_delete {
  text-align: center;
}
</style>